import storeDateSelectorResolve from "../../directive/store-date-selector/store-date-selector.resolve";
import receiptsDetailsResolve from "./receiptsDetails.resolve";

export default function routes($stateProvider) {
	$stateProvider.state("receiptsDetailsPage", {
		url: "/receiptsDetails/:stores?startDate&endDate&offset",
		template: require("./receiptsDetails.html"),
		resolve: {
			...storeDateSelectorResolve,
			...receiptsDetailsResolve,
			brand: [
				"Brand",
				function(Brand) {
					return Brand.get();
				}
			],
			receiptsDetailsLoader: [
				"Receipt",
				"selectedStore",
				"endDate",
				"startDate",
				"offset",
				function(Receipt, selectedStore, endDate, startDate, offset) {
					return _ =>
						Receipt.getDetails({
							stores: JSON.stringify(selectedStore.storeIds),
							startDate,
							endDate,
							offset
						});
				}
			],
			receiptsDetails: [
				"receiptsDetailsLoader",
				function(receiptsDetailsLoader) {
					return receiptsDetailsLoader();
				}
			],
			receiptsDetailsLoaderForExport: [
				"Receipt",
				"selectedStore",
				"endDate",
				"startDate",
				"offset",
				function(Receipt, selectedStore, endDate, startDate, offset) {
					var limit = 10000;
					return _ =>
						Receipt.getDetails({
							stores: JSON.stringify(selectedStore.storeIds),
							startDate,
							endDate,
							offset,
							limit
						});
				}
			],
			receiptsDetailsForExport: [
				"receiptsDetailsLoaderForExport",
				function(receiptsDetailsLoaderForExport) {
					return receiptsDetailsLoaderForExport();
				}
			]
		},
		controller: "ReceiptsDetailsController",
		controllerAs: "receiptsDetails"
	});
}

routes.$inject = ["$stateProvider"];



// WEBPACK FOOTER //
// ./src/page/receiptsDetails/receiptsDetails.routes.js